import { render } from "./ManageApplyDistributors.vue?vue&type=template&id=8f9404c6"
import script from "./ManageApplyDistributors.vue?vue&type=script&lang=js"
export * from "./ManageApplyDistributors.vue?vue&type=script&lang=js"

import "./ManageApplyDistributors.vue?vue&type=style&index=0&id=8f9404c6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__